export default "__VITE_ASSET__BcyBTLDj__"